import type { Dict } from './en';

export const pt: Dict = {
  subtitle: 'Adivinhe o país do dia',
  modes: { classic: 'Clássico', flag: 'Bandeira', outline: 'Silhueta', connections: 'Conexões', trivia: 'Trivia', draw: 'Desenho' },
  recommendations: {
    title: 'Também pode gostar',
    open: 'Abrir {name}',
    games: {
      wormillion: 'Jogo diário de geografia com respostas raras',
      stardewdle: 'Desafios diários no universo de Stardew Valley',
      cascadle: 'Jogo diário de palavras em cascata',
      farhike: 'Desafio diário no mapa com países pouco lembrados',
    },
  },
  draw: {
    subtitle: 'Desenhe a silhueta de memória',
    askLabel: 'Desenhe este país',
    drawingLabel: 'Desenhando',
    askHint: 'De memória — sem referência, uma tentativa.',
    blank: 'uma folha em branco — sem decalcar',
    canvasLabel: 'Área de desenho',
    start: 'Começar a desenhar',
    undo: 'Desfazer',
    clear: 'Limpar',
    done: 'Concluir',
    next: 'Próximo país',
    score: 'Pontuação',
    accuracy: 'Precisão',
    coverage: 'Cobertura',
    deviation: 'Desvio',
    legendTrue: 'Silhueta real',
    legendYours: 'Seu traço',
    legendOut: 'Passou do limite',
    legendIn: 'Ficou aquém',
    pts: 'pts',
    learnMore: 'Saber mais',
    ranks: [
      'Cartógrafo Real',
      'Mestre cartógrafo',
      'Bom agrimensor',
      'Mão firme',
      'Aprendiz',
      'Esboço tosco',
      'De volta ao atlas',
    ],
  },
  trivia: {
    subtitle: 'Dez perguntas de geografia por dia',
    loading: 'A carregar as perguntas de hoje…',
    question: 'Pergunta',
    correct: 'Certo!',
    wrong: 'Quase',
    next: 'Próxima pergunta',
    seeResult: 'Ver resultado',
    xpNote: '3 XP por resposta certa, +10 se acertares as dez.',
    comeBack: 'Dez perguntas novas à meia-noite UTC.',
    tiers: ['Impecável — 10 em 10!', 'Muito bem jogado.', 'Nada mau. Até amanhã.', 'Dia difícil. O mundo é grande.'],
  },
  conn: {
    subtitle: 'Ordena 16 países em 4 grupos',
    oneAway: 'Quase!',
    shuffle: 'Baralhar',
    deselect: 'Desmarcar',
    submit: 'Enviar',
    mistakes: 'Erros',
    solved: 'Resolvido!',
    lost: 'Para a próxima!',
    nextPuzzle: 'Seguinte',
    flawless: 'Impecável — sem erros!',
    wellPlayed: 'Bem ordenado!',
    lostSub: 'Os quatro grupos estão revelados acima.',
    guesses: 'Tentativas',
  },
  soon: 'em breve',
  streak: 'Sequência',
  today: 'Hoje',
  yesterday: 'Ontem',
  nextIn: 'Próximo país em',
  daily: 'Diário',
  unlimited: 'Unlimited',
  nextCountry: 'Próximo país',
  skip: 'Pular',
  solved: 'Resolvidos',
  best: 'Recorde',
  emptyHint: 'Faça seu primeiro palpite para revelar as dicas.',
  boardScrollLabel: 'Tabela comparativa de palpites. Deslize horizontalmente para ver todas as pistas.',
  legend: { correct: 'Combina', incorrect: 'Sem combinação', numbers: 'resposta ↑ maior · ↓ menor', distance: 'mais perto → mais longe' },
  placeholder: 'Digite um país…',
  guess: 'Adivinhar',
  won: 'Resolvido!',
  lost: 'Sem tentativas',
  answerWas: 'O país era',
  answerCard: { viewProfile: 'Ver perfil', northernHemisphere: 'Hemisfério Norte', southernHemisphere: 'Hemisfério Sul' },
  share: 'Compartilhar',
  copyLink: 'Copiar link',
  copyResult: 'Copiar resultado',
  copyEmbed: 'Copiar incorporação',
  saveImage: 'Salvar imagem',
  shareToday: 'Compartilhar hoje',
  copied: 'Copiado!',
  cols: { region: 'Região', pop: 'Pop.', area: 'Área', borders: 'Vizinhos', gdp: 'PIB', temp: 'Temp.', dist: 'Distância' },
  colTips: {
    region: "Em que continente fica o país. Verde significa o mesmo continente da resposta.",
    dist: "Distância em linha reta entre o teu palpite e a resposta. Vermelho é longe, verde é perto; a seta aponta para a resposta.",
    borders: "Com quantos países partilha fronteira terrestre. ↑ significa que a resposta tem mais.",
    temp: "Temperatura média anual, 1991–2020, calculada sobre todo o país — não da capital.",
    pop: "População total. ↑ significa que a resposta tem mais habitantes.",
    area: "Área em km². ↑ significa que a resposta é maior.",
    gdp: "PIB per capita em dólares. ↑ significa que a resposta é mais rica por habitante.",
  },
  puzzle: {
    flag: 'De que país é esta bandeira?',
    outline: 'Que país tem esta silhueta?',
  },
  account: {
    signIn: 'Entrar',
    withGoogle: 'Continuar com Google',
    withDiscord: 'Continuar com Discord',
    tagline: 'Salve sua sequência em todos os dispositivos',
    signOut: 'Sair',
    level: 'Nv',
    viewProfile: 'Ver perfil',
    editProfile: 'Editar perfil',
  },
  settings: {
    title: 'Editar perfil',
    avatar: 'Avatar',
    change: 'Alterar',
    displayName: 'Nome',
    bio: 'Bio',
    bioPh: 'Conta aos exploradores sobre ti…',
    birthday: 'Aniversário',
    country: 'País',
    countryNone: 'Não definido',
    gender: 'Género',
    genders: { male: 'Masculino', female: 'Feminino', other: 'Outro', na: 'Prefiro não dizer' },
    socials: 'Redes sociais',
    invalidUrl: 'Insere um URL válido para essa plataforma.',
    date: { year: 'Ano', month: 'Mês', day: 'Dia' },
    save: 'Guardar',
    saving: 'A guardar…',
    saved: 'Guardado',
    signInRequired: 'Inicia sessão para editar o teu perfil.',
    cropTitle: 'Recortar avatar',
    cropHint: 'Arrasta para mover · roda para zoom',
    apply: 'Aplicar',
    cancel: 'Cancelar',
    pick: 'Escolher imagem',
    uploadError: 'Falha no envio — tenta uma imagem menor.',
  },
  netError: 'Falha de rede, tente novamente.',
  offlinePractice: 'Treino offline — não pontua.',
  xp: 'XP',
  levelUp: 'Subiu de nível!',
  honors: {
    title: 'Emblemas e medalhas',
    intro: 'Cada desafio que concluis fica registado de três formas — um nível que carregas, uma medalha que ganhas e um emblema que defendes.',
    levelT: 'Emblemas de nível',
    levelD: 'A XP do jogo diário leva-te por 14 embarcações gravadas da jornada, do bordão do caminhante à nau capitânia que dá a volta ao mundo.',
    dailyT: 'Medalhas diárias',
    dailyD: 'A classificação de Hoje ordena os exploradores por quantos dos seis modos concluem e depois por quantas tentativas usaram. Os três primeiros levam ouro, prata e bronze — contados no teu perfil para sempre.',
    boardT: 'Emblemas de classificação',
    boardD: 'Mantém um lugar no pódio das classificações de Sequência, Ilimitado ou Nível e cada dia fica gravado no emblema. Os dias de ouro, prata e bronze contam-se em separado.',
    cta: 'Ver a classificação',
  },
  lb: {
    scoreBreakdown: "Detalhe da pontuação",
    scoreAvg: "Média",
    scoreNote: "Ordenado primeiro por modos concluídos e depois por esta média.",
    title: 'Classificação',
    today: 'Hoje',
    streak: 'Sequência',
    level: 'Nível',
    unlimited: 'Ilimitado',
    connections: 'Conexões',
    myRank: 'Sua posição',
    empty: 'Ainda sem registos — seja o primeiro.',
    signInToRank: 'Inicie sessão para aparecer na classificação.',
    guesses: 'tentativas',
    guess1: 'tentativa',
    totalSolved: 'Resolvidos',
    yourStats: 'As tuas estatísticas',
    back: 'Voltar ao jogo',
    nav: 'Classificação',
    viewAll: 'Ver tudo',
    dailyMedals: 'Medalhas diárias',
    heldBadges: 'Emblemas de classificação',
    notFound: 'Explorador não encontrado.',
  },
  privacy: {
    title: 'Política de Privacidade',
    updated: 'Última atualização: 28 de junho de 2026',
    sections: [
      {
        h: 'Quem somos',
        p: ['O GeoDle ("nós") é um jogo diário e gratuito de adivinhar países, disponível em geodle.org.'],
      },
      {
        h: 'O que recolhemos',
        p: [
          'Dados de jogo: as tuas tentativas, progresso diário, sequência e pontos de experiência — para fazer o jogo funcionar e sincronizá-lo entre os teus dispositivos.',
          'Dados de conta (apenas se iniciares sessão com Google ou Discord): um identificador único, o teu nome visível e o teu avatar. Nunca recebemos a tua palavra-passe.',
        ],
      },
      {
        h: 'Como usamos os teus dados',
        p: [
          'Para guardar e sincronizar o teu progresso, calcular sequências e níveis, e mostrar classificações e perfis públicos dos jogadores com sessão iniciada.',
          'Não vendemos os teus dados nem os usamos para publicidade.',
        ],
      },
      {
        h: 'Análise e cookies',
        p: [
          'Usamos o Google Analytics e o Microsoft Clarity para perceber o uso anónimo e agregado. Estes serviços podem definir os seus próprios cookies; não os usamos para te identificar pessoalmente.',
          'Usamos um cookie próprio para te manter com sessão iniciada e sincronizar o teu progresso.',
        ],
      },
      {
        h: 'Os teus direitos e eliminação',
        p: [
          'Podes eliminar permanentemente a tua conta e todos os dados associados a qualquer momento com o botão abaixo. A eliminação é imediata.',
        ],
      },
      { h: 'Contacto', p: ['Dúvidas sobre os teus dados? Escreve para contact@geodle.org.'] },
    ],
    deleteAccount: 'Eliminar a minha conta e dados',
    deleteConfirm: 'Isto elimina permanentemente a tua conta e todo o progresso. Continuar?',
    deleted: 'A tua conta e dados foram eliminados.',
  },
  terms: {
    title: 'Termos de Serviço',
    updated: 'Última atualização: 28 de junho de 2026',
    sections: [
      {
        h: 'Aceitação',
        p: ['Ao usar o GeoDle aceitas estes termos. Se não concordas, não uses o serviço.'],
      },
      {
        h: 'O serviço',
        p: [
          'O GeoDle é um jogo diário e gratuito fornecido "tal como está", para entretenimento pessoal e não comercial. Podemos alterar, suspender ou descontinuar qualquer parte a qualquer momento.',
        ],
      },
      {
        h: 'Contas e jogo justo',
        p: [
          'Iniciar sessão é opcional e serve para sincronizar o teu progresso e classificar-te. És responsável pela atividade da tua conta.',
          'Não faças batota, não automatizes o jogo nem manipules pontuações, sequências ou classificações. Podemos remover entradas ou contas que o façam.',
        ],
      },
      {
        h: 'Uso aceitável',
        p: [
          'Escolhe um nome e um avatar que não sejam ofensivos, infratores ou enganadores. Podemos remover conteúdo ou contas que violem esta regra.',
        ],
      },
      {
        h: 'Propriedade intelectual',
        p: [
          'Os dados de países vêm de conjuntos abertos (mledoze/countries, Natural Earth). O GeoDle é um projeto independente, sem afiliação a qualquer governo ou organização.',
        ],
      },
      {
        h: 'Isenção e responsabilidade',
        p: [
          'O serviço é fornecido sem garantias de qualquer tipo. Na medida permitida por lei, não somos responsáveis por danos resultantes do teu uso do GeoDle.',
        ],
      },
      {
        h: 'Alterações',
        p: ['Podemos atualizar estes termos periodicamente. Continuar a usar o serviço após uma alteração significa que aceitas os novos termos.'],
      },
      { h: 'Contacto', p: ['Dúvidas? Escreve para contact@geodle.org.'] },
    ],
  },
  country: {
    whereOnEarth: 'Onde fica no mundo',
    atAGlance: 'Resumo',
    howItCompares: 'Comparação',
    neighbours: 'Países vizinhos',
    inGeoDle: '{name} no GeoDle',
    exploreNearby: 'Explorar por perto',
    faqTitle: 'Perguntas frequentes',
    metaTitle: '{name} — Capital, população, área e dados | GeoDle',
    metaDesc: '{name}: capital {capital}, população {pop}, área {area} km². O {rankPop} país mais populoso, em {region}. Dados, mapa, vizinhos e mais.',
    getToKnow: 'Conheça {name}',
    k: { history: 'Momentos históricos', people: 'Figuras célebres', landmarks: 'Pontos turísticos', culture: 'Cultura e sabor' },
    sources: 'Fontes',
    listTitle: 'Países',
    listSearch: 'Procurar países…',
    listAll: 'Todas as regiões',
    listCount: '{n} países',
    listEmpty: 'Nenhum país corresponde à sua pesquisa.',
    promoTitle: 'Explore todos os países',
    promoDesc: 'Bandeiras, capitais, população e um globo interativo: uma página completa para os 194 países.',
    promoCta: 'Ver países',
    metaTitleList: 'Todos os países do mundo — bandeiras, capitais e dados | GeoDle',
    metaDescList: 'Explore todos os países: bandeiras, capitais, população, área e mais. Pesquise e filtre por região, e descubra o mundo num globo interativo.',
    play: 'Jogar',
    guessFlag: 'Adivinhe a bandeira',
    guessOutline: 'Adivinhe o contorno',
    back: 'GeoDle',
    notFound: 'País não encontrado.',
    landlocked: 'Sem litoral',
    coastal: 'Com costa',
    north: 'Norte',
    south: 'Sul',
    landBorders: '{n} fronteiras terrestres',
    landBorder: '1 fronteira terrestre',
    noBorders: '{name} não tem fronteiras terrestres.',
    locLede: '{name} fica em {subregion}, {region}.',
    locLandlocked: 'Não tem saída para o mar.',
    locCoastal: 'Tem costa marítima.',
    locBorders: 'Faz fronteira terrestre com {n} países.',
    locBorder: 'Faz fronteira terrestre com um país.',
    locIsland: 'Por ser um país insular, não tem fronteiras terrestres.',
    f: { capital: 'Capital', population: 'População', area: 'Área', region: 'Região', subregion: 'Sub-região', coast: 'Costa', hemisphere: 'Hemisfério', iso: 'ISO', languages: 'Idiomas', currency: 'Moeda', timezone: 'Fuso horário', calling: 'Indicativo', driving: 'Condução', tld: 'Domínio', nativeName: 'Nome nativo' },
    s: {
      popWorld: 'país mais populoso do mundo (de {total}).',
      popRegion: 'mais populoso da {region} (de {total}).',
      areaLargest: 'maior por área',
      biggerThan: 'maior que {x}',
      smallerThan: 'menor que {x}',
      perKm2: 'habitantes por km²',
      sparse: 'pouco povoado',
      moderate: 'densidade média',
      dense: 'muito povoado',
      morePeople: 'mais habitantes que {x}',
      fewerPeople: 'menos que {x}',
      vs: 'vs',
      neighbours: 'vizinhos terrestres',
      neighbour: 'vizinho terrestre',
    },
    q: {
      capitalQ: 'Qual é a capital de {name}?',
      capitalA: 'A capital de {name} é {capital}.',
      popQ: 'Qual é a população de {name}?',
      popA: '{name} tem cerca de {pop} habitantes — o {rank} país mais populoso do mundo.',
      areaQ: 'Qual é o tamanho de {name}?',
      areaA: '{name} ocupa {area} km², o {rank} maior país por área.',
      regionQ: 'Em que região fica {name}?',
      regionA: '{name} fica em {subregion}, {region}.',
    },
  },
  footer:
    'Dados dos países: mledoze/countries (ODbL) · Dados de mapas: Natural Earth (domínio público). GeoDle é um projeto independente, sem afiliação a qualquer governo ou organização.',
};
